import Layout from '@/views/layout'
export default  {
  path: '/traffic',
  menuName: '车务管理',
  component: Layout,
  redirect: 'noredirect',
  name: 'traffic',
  meta: { title: 'traffic', icon: 'icon-system', iconType: 'svg' },
  children: [
    {
      path: 'repair',
      name: 'repair',
      menuName: '维修记录',
      component: () => import('@/views/traffic/repair'),
      meta: { title: 'repair', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'maintain',
      name: 'maintain',
      menuName: '保养记录',
      component: () => import('@/views/traffic/maintain'),
      meta: { title: 'maintain', icon: 'user', iconType: 'svg' }
    }
  ]
}